import {useState, useEffect} from 'react'

export default (maxWidth = 767) => {
    const [mobile, setMobile] = useState(window.innerWidth <= maxWidth)

    useEffect(() => {
        const handleResize = () => {
            setMobile(window.innerWidth <= maxWidth)
        }
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [maxWidth])

    return {mobile}
}
